// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #f3f5f4;
  --surface: #ffffff;
  --ink: #18211e;
  --muted: #5e6b66;
  --line: #dde3e0;
  --accent: #0f6e5a;
  --accent-press: #0b5546;
  --accent-weak: #e6f1ee;
  --danger: #b23b2e;
  --warn: #8a5a12;
  /* themeable accents for the dark context strip, brand mark, and code blocks */
  --strip-bg: #11201c;
  --strip-fg: #cfe6df;
  --strip-eyebrow: #6fae9d;
  --strip-link: #8fd0bf;
  --strip-link-hover: #ffffff;
  --code-bg: #0f1c19;
  --radius: 6px;
  --mono: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
  --sans: -apple-system, BlinkMacSystemFont, "Segoe UI", "Microsoft YaHei", Roboto, system-ui, sans-serif;
}

* { box-sizing: border-box; }

html, body {
  margin: 0;
  padding: 0;
  background: var(--bg);
  color: var(--ink);
  font-family: var(--sans);
  font-size: 14px;
  line-height: 1.5;
}

/* The HTML \`hidden\` attribute must win over any element's display rule
   (e.g. .drawer { display:flex }), otherwise toggling hidden does nothing. */
[hidden] { display: none !important; }

.boot {
  padding: 40px 20px;
  color: var(--muted);
  font: 13px/1.5 var(--mono);
  text-align: center;
}

#app { display: flex; flex-direction: column; height: 100vh; overflow: hidden; }

/* ---- top bar ---- */
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: var(--surface);
  border-bottom: 1px solid var(--line);
  position: sticky;
  top: 0;
  z-index: 5;
}
.brand { display: flex; align-items: center; gap: 7px; }
.brand-mark {
  width: 12px; height: 12px; border-radius: 3px;
  background: linear-gradient(135deg, var(--accent), var(--accent-press));
}
.brand-name { font-weight: 650; letter-spacing: 0.2px; font-size: 13px; }
.badge {
  font: 10px/1 var(--mono);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--accent);
  background: var(--accent-weak);
  padding: 3px 5px;
  border-radius: 4px;
}

.topbar-actions { display: flex; gap: 2px; }
.icon-btn {
  border: 1px solid transparent;
  background: transparent;
  color: var(--muted);
  font-size: 14px;
  width: 26px; height: 26px;
  border-radius: var(--radius);
  cursor: pointer;
}
.icon-btn:hover { background: var(--bg); color: var(--ink); }

/* ---- context strip (signature element) ---- */
.context-strip {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 9px 16px;
  background: var(--strip-bg);
  color: var(--strip-fg);
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
}
.context-strip .eyebrow { color: var(--strip-eyebrow); }
.context-text { font: 12px/1.4 var(--mono); flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.eyebrow {
  font: 10px/1 var(--mono);
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--muted);
}

.link-btn {
  background: none; border: none; padding: 0;
  color: var(--strip-link); font: 11px/1 var(--mono); cursor: pointer;
  text-decoration: underline; text-underline-offset: 2px;
}
.link-btn:hover { color: var(--strip-link-hover); }

/* ---- panel / cards ---- */
.panel { padding: 16px 16px 8px; display: flex; flex-direction: column; gap: 14px; }

.card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 11px;
}
.card-title { display: flex; align-items: center; gap: 8px; margin: 0; justify-content: space-between; }
.card-title .eyebrow { color: var(--ink); opacity: 0.7; }

.btn-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
.btn-grid.two { grid-template-columns: repeat(2, 1fr); }

.btn {
  appearance: none;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink);
  border-radius: var(--radius);
  padding: 6px 10px;
  font-size: 12.5px;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;
}
.btn:hover { border-color: var(--accent); background: var(--accent-weak); }
.btn:active { transform: translateY(0.5px); }
.btn:disabled { opacity: 0.5; cursor: not-allowed; }

.btn-primary { background: var(--accent); color: #fff; border-color: var(--accent); width: 100%; font-weight: 600; }
.btn-primary:hover { background: var(--accent-press); border-color: var(--accent-press); }
.btn-ghost { background: var(--bg); }
.btn-sm { padding: 4px 7px; font-size: 11.5px; }

textarea, input[type="text"], input[type="password"], select {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 9px 10px;
  font: 13px var(--sans);
  background: var(--surface);
  color: var(--ink);
}
textarea { resize: vertical; min-height: 72px; line-height: 1.5; }
:focus-visible { outline: 2px solid var(--accent); outline-offset: 1px; }

.seg { display: inline-flex; border: 1px solid var(--line); border-radius: var(--radius); overflow: hidden; }
.seg button {
  border: none; background: var(--surface); padding: 6px 11px; font-size: 12px; cursor: pointer; color: var(--muted);
}
.seg button[aria-pressed="true"] { background: var(--accent); color: #fff; }
.seg button + button { border-left: 1px solid var(--line); }

.row { display: flex; gap: 8px; align-items: center; }
.row > * { flex: 1; }
.stack { display: flex; flex-direction: column; gap: 8px; }
.label-sm { font-size: 12px; color: var(--muted); margin: 0; display: block; }

/* ---- output ---- */
.output-wrap { padding: 8px 16px 18px; margin-top: auto; }
.output-head {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 8px;
}
.output-actions { display: flex; gap: 6px; flex-wrap: wrap; margin-left: auto; }
.copy-btn { background: var(--bg); }
.copy-btn:disabled { opacity: 0.5; }
.copy-btn.is-error { color: var(--danger); border-color: var(--danger); }
.output {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 12px 14px;
  min-height: 90px;
  max-height: 44vh;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 13.5px;
  line-height: 1.62;
}
.output:empty::before { content: "结果会显示在这里。"; color: var(--muted); }
.output .log { font: 12px/1.6 var(--mono); color: var(--muted); }
.output .log b { color: var(--accent); font-weight: 600; }

/* rendered markdown (shared by the single result view and chat bubbles) */
.md-body { white-space: normal; }
.md-body > :first-child { margin-top: 0; }
.md-body > :last-child { margin-bottom: 0; }
.md-body h3,
.md-body h4,
.md-body h5,
.md-body h6 { margin: 10px 0 4px; line-height: 1.3; font-weight: 650; }
.md-body h3 { font-size: 14px; }
.md-body h4 { font-size: 13px; }
.md-body h5, .md-body h6 { font-size: 12px; color: var(--muted); }
.md-body p { margin: 6px 0; }
.md-body ul,
.md-body ol { margin: 8px 0; padding-left: 20px; }
.md-body li { margin: 3px 0; }
.md-body li > ul, .md-body li > ol { margin: 3px 0; }
.md-body a { color: var(--accent); text-underline-offset: 2px; }
.md-body code {
  font-family: var(--mono); font-size: 12.5px;
  background: var(--bg); padding: 1px 5px; border-radius: 4px;
}
.md-body pre {
  background: var(--code-bg); color: #d7e9e3;
  border-radius: var(--radius); padding: 10px 12px; margin: 10px 0; overflow: auto;
}
.md-body pre code { background: none; color: inherit; padding: 0; font-size: 12.5px; }
.md-body blockquote {
  margin: 10px 0; padding: 4px 12px; color: var(--muted);
  border-left: 3px solid var(--accent-weak);
}
.md-body hr { border: none; border-top: 1px solid var(--line); margin: 14px 0; }
.md-body table {
  border-collapse: collapse; width: 100%; margin: 10px 0; font-size: 12.5px;
}
.md-body th, .md-body td {
  border: 1px solid var(--line); padding: 6px 8px; text-align: left;
}
.md-body th { background: var(--bg); font-weight: 600; }
.md-body strong { font-weight: 650; }

/* ---- chips (recommended quick-actions) ---- */
.chips { display: flex; flex-wrap: wrap; gap: 6px; }
.chip {
  appearance: none;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11.5px;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.chip:hover { border-color: var(--accent); color: var(--accent); background: var(--accent-weak); }
.chip[aria-pressed="true"] { background: var(--accent); color: #fff; border-color: var(--accent); }
.chip[aria-pressed="true"]:hover { background: var(--accent-press); }
.chip:disabled { opacity: 0.45; cursor: not-allowed; }
.net-row { margin-top: 2px; }
.net-row .net-toggle { flex: 0 0 auto; }

/* agent tool trace shown above an assistant reply */
.trace {
  font: 11px/1.5 var(--mono);
  color: var(--muted);
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 4px 7px;
  margin-bottom: 6px;
}

/* footer model line */
.model-footer {
  padding: 4px 12px 5px;
  font: 10.5px/1.4 var(--mono);
  color: var(--muted);
  border-top: 1px solid var(--line);
}

/* settings drawer separator */
.drawer-sep { border: none; border-top: 1px solid var(--line); margin: 8px 0 2px; }

/* ---- chat transcript ---- */
.turn { border-radius: 8px; padding: 7px 9px; position: relative; }
.turn + .turn { margin-top: 6px; }
.turn .role {
  display: block;
  font: 10px/1 var(--mono);
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--muted);
  margin-bottom: 3px;
}
.turn.user { background: var(--accent-weak); border: 1px solid #d3e6e0; }
.turn.user .role { color: var(--accent); }
.turn.assistant { background: var(--surface); border: 1px solid var(--line); }
.turn-body { font-size: 13px; line-height: 1.55; white-space: pre-wrap; }

/* User messages: collapse long content (e.g. when Office data is attached). */
.turn.user .turn-body {
  max-height: 10em;
  overflow: hidden;
}
.turn.user .turn-body.is-expanded { max-height: none; overflow: visible; }
.turn-expand-btn {
  display: block;
  width: 100%;
  border: none;
  background: none;
  color: var(--muted);
  font-size: 11px;
  cursor: pointer;
  padding: 2px 0;
  text-align: center;
  opacity: 0.6;
  transition: opacity 0.12s;
}
.turn-expand-btn:hover { opacity: 1; color: var(--accent); }

/* Per-message action toolbar (copy + delete), revealed on hover. */
.turn-actions {
  position: absolute;
  right: 4px; bottom: 4px;
  display: inline-flex;
  gap: 3px;
  opacity: 0;
  transition: opacity 0.12s ease;
}
.turn:hover .turn-actions,
.turn-actions:focus-within { opacity: 1; }
.turn-act-btn {
  width: 20px; height: 20px;
  padding: 0;
  display: inline-flex; align-items: center; justify-content: center;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 4px;
  color: var(--muted);
  font-size: 11px; line-height: 1;
  cursor: pointer;
  transition: color 0.12s ease, border-color 0.12s ease, background 0.12s ease;
}
.turn-act-btn:hover { color: var(--accent); border-color: var(--accent); background: var(--bg); }
.turn-act-btn.is-danger:hover { color: var(--danger); border-color: var(--danger); }
.turn-act-btn.is-ok { color: var(--accent); border-color: var(--accent); }

.status-line { font: 11px/1.4 var(--mono); color: var(--muted); margin: 4px 0 0; min-height: 14px; }
.status-line.error { color: var(--danger); }
.status-line.warn { color: var(--warn); }

/* ---- settings modal ---- */
.modal-overlay {
  position: fixed; inset: 0;
  background: rgba(10, 20, 17, 0.45);
  display: flex; align-items: center; justify-content: center;
  z-index: 50;
  padding: 16px;
  backdrop-filter: blur(2px);
}
.modal-card {
  background: var(--surface);
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  border-radius: 12px;
  display: flex; flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: modalPop 0.18s ease-out;
}
@keyframes modalPop {
  from { transform: translateY(8px) scale(0.98); opacity: 0; }
  to   { transform: translateY(0)    scale(1);     opacity: 1; }
}
.modal-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid var(--line);
  flex: 0 0 auto;
}
.modal-title { font-weight: 650; font-size: 14px; letter-spacing: 0.2px; }
.modal-body {
  padding: 14px;
  overflow-y: auto;
  flex: 1 1 auto;
  display: flex; flex-direction: column; gap: 11px;
}
.modal-foot {
  display: flex; gap: 8px;
  padding: 10px 14px;
  border-top: 1px solid var(--line);
  background: var(--surface);
  flex: 0 0 auto;
}
.modal-foot .btn { flex: 1; }
/* Keep legacy .drawer-* class names usable for any leftover markup. */
.drawer-head { display: flex; align-items: center; justify-content: space-between; }
.drawer-foot { display: flex; gap: 8px; margin-top: 4px; }
.drawer-foot .btn { flex: 1; }
.field { display: flex; flex-direction: column; gap: 6px; font-size: 12px; color: var(--muted); }
.field input, .field select { color: var(--ink); }
.field > span { font-weight: 500; }
.hint { font-size: 11px; color: var(--muted); margin: 2px 0; line-height: 1.5; }
.hint code { font-family: var(--mono); background: var(--bg); padding: 1px 4px; border-radius: 3px; }
/* In-body small buttons (测试 / 导入 / 导出): keep them tight, not full-width. */
.modal-body .row .btn { flex: 0 0 auto; min-width: 72px; }

@media (prefers-reduced-motion: reduce) {
  .btn { transition: none; }
}

/* ---- themes ---- */
:root[data-theme="blue"] {
  --accent: #2563eb;
  --accent-press: #1d4ed8;
  --accent-weak: #e7effd;
  --strip-bg: #0c1a2e;
  --strip-fg: #d2e2f6;
  --strip-eyebrow: #6f9fd6;
  --strip-link: #9cc0ee;
  --code-bg: #0c1726;
}
:root[data-theme="anthropic"] {
  --bg: #f4f1ea;
  --surface: #fffdf8;
  --line: #e6ded0;
  --accent: #c8633b;
  --accent-press: #aa4f2c;
  --accent-weak: #f6e9e0;
  --strip-bg: #2a2018;
  --strip-fg: #ecdcc9;
  --strip-eyebrow: #c79b78;
  --strip-link: #e3b791;
  --strip-link-hover: #fff5ea;
  --code-bg: #241c14;
}
:root[data-theme="govred"] {
  --accent: #c8102e;
  --accent-press: #9e0c24;
  --accent-weak: #fbe6ea;
  --strip-bg: #2a1012;
  --strip-fg: #f3d6d9;
  --strip-eyebrow: #cf8f95;
  --strip-link: #ec9aa1;
  --code-bg: #260e10;
}

/* theme switcher swatches */
.theme-row { display: flex; flex-wrap: wrap; gap: 8px; }
.swatch {
  display: inline-flex; align-items: center; gap: 6px;
  border: 1px solid var(--line); background: var(--surface); color: var(--ink);
  border-radius: 999px; padding: 5px 11px; font-size: 12px; cursor: pointer;
}
.swatch .dot { width: 12px; height: 12px; border-radius: 50%; flex: 0 0 auto; }
.swatch[aria-pressed="true"] { border-color: var(--accent); box-shadow: inset 0 0 0 1px var(--accent); }

/* ---- Excel multi-sheet picker ---- */
.sheet-head { display: flex; align-items: center; justify-content: space-between; }
.link-btn-2 {
  background: none; border: none; padding: 0; cursor: pointer;
  color: var(--accent); font-size: 12px; text-decoration: underline; text-underline-offset: 2px;
}
.sheet-list {
  display: flex; flex-direction: column; gap: 2px;
  max-height: 132px; overflow: auto;
  border: 1px solid var(--line); border-radius: var(--radius);
  padding: 6px 8px; background: var(--surface);
}
.sheet-item { display: flex; align-items: center; gap: 8px; font-size: 13px; cursor: pointer; }
.sheet-item input { width: auto; }

/* ---- history dropdown ---- */
.history-dropdown {
  position: absolute;
  top: 44px;
  right: 4px;
  width: 260px;
  max-height: 50vh;
  overflow-y: auto;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  z-index: 30;
  display: flex;
  flex-direction: column;
}
.history-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 6px 8px; border-bottom: 1px solid var(--line);
}
.history-head-actions { display: flex; align-items: center; gap: 4px; }
.history-list { padding: 4px 0; }
.history-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: 6px 8px; font-size: 12.5px; cursor: pointer;
  border-bottom: 1px solid var(--bg);
}
.history-item:hover { background: var(--accent-weak); }
.history-item-title { flex: 1; display: flex; align-items: center; gap: 6px; overflow: hidden; margin-right: 6px; color: var(--ink); }
.history-item-title-text { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.history-host-badge {
  flex: none; font: 10px/1.5 var(--mono); letter-spacing: 0.4px;
  color: var(--muted); background: var(--bg);
  padding: 1px 5px; border-radius: 4px;
}
.history-item-date { font: 11px/1.4 var(--mono); color: var(--muted); margin-right: 6px; }
.history-del-btn {
  background: none; border: none; color: var(--muted); font-size: 14px; cursor: pointer;
  padding: 2px 4px; border-radius: 4px; line-height: 1;
  opacity: 0;
  transition: opacity 0.12s ease;
}
.history-item:hover .history-del-btn,
.history-del-btn:focus-visible { opacity: 1; }
.history-del-btn:hover { color: var(--danger); background: var(--bg); }
.history-empty { text-align: center; padding: 16px; color: var(--muted); font-size: 12px; }


/* ===========================================================================
   Chatbot layout (transcript + bottom composer)
   =========================================================================== */
.extra-panel { padding: 8px 12px 0; display: flex; flex-direction: column; gap: 8px; flex: 0 0 auto; }

.transcript {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* welcome / empty state — horizontally & vertically centered via flex */
.welcome {
  margin: auto;
  padding: 16px 12px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  text-align: center;
  color: var(--muted);
  max-width: 360px;
}
.welcome-greet {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
}
.welcome-emoji { font-size: 28px; line-height: 1; }
.welcome-title { font-size: 15px; font-weight: 650; color: var(--ink); }
.welcome-sub { font-size: 11.5px; line-height: 1.5; max-width: 300px; }

/* host capability bullets */
.welcome-caps {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  text-align: left;
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 8px 10px;
  width: 100%;
}
.welcome-cap {
  font-size: 11.5px;
  color: var(--muted);
  display: flex;
  gap: 5px;
  align-items: flex-start;
}
.welcome-cap::before { content: "✓"; color: var(--accent); font-weight: 700; flex: 0 0 auto; }

/* example question groups */
.welcome-examples { display: flex; flex-direction: column; gap: 8px; width: 100%; }
.welcome-group { display: flex; flex-direction: column; gap: 4px; }
.welcome-group-label {
  font: 10px/1 var(--mono);
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--muted);
  text-align: left;
}
.welcome-chips { display: flex; flex-wrap: wrap; gap: 5px; }
.welcome-chip {
  max-width: 100%;
  text-align: left;
  white-space: normal;
  line-height: 1.4;
  padding: 6px 9px;
  font-size: 11.5px;
}

/* chat bubbles (overrides the older .turn block for the new flow) */
.transcript .turn { max-width: 92%; }
.transcript .turn.user { align-self: flex-end; }
.transcript .turn.assistant { align-self: flex-start; }

/* last-result actions bar (sits above the composer) */
.last-actions {
  flex: 0 0 auto;
  border-top: 1px solid var(--line);
  background: var(--surface);
  padding: 6px 10px;
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
}
.last-actions .output-actions { display: flex; gap: 6px; flex-wrap: wrap; flex: 1; }
.last-actions .copy-btn { flex: 0 0 auto; margin-left: auto; background: var(--bg); }

/* bottom composer */
.composer {
  flex: 0 0 auto;
  border-top: 1px solid var(--line);
  background: var(--surface);
  padding: 6px 10px 8px;
}
.composer .status-line { margin: 0 0 4px; min-height: 12px; }
.composer textarea {
  width: 100%;
  min-height: 44px;
  max-height: 140px;
  resize: none;
  line-height: 1.5;
  box-sizing: border-box;
  font-size: 13px;
  padding: 7px 9px;
}
.composer-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}
.composer-bar .net-toggle { flex: 0 0 auto; height: 30px; line-height: 18px; font-size: 12px; }
.btn-send {
  flex: 0 0 auto;
  min-width: 60px;
  width: auto;
  height: 30px;
  font-weight: 600;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 12.5px;
}
.btn-stop {
  background: var(--danger);
  color: #fff;
  border-color: var(--danger);
}
.btn-stop:hover { background: #8e2f24; border-color: #8e2f24; }

/* ---- confirm modal ---- */
.confirm-overlay {
  position: fixed; inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 100;
  backdrop-filter: blur(2px);
}
.confirm-card {
  background: var(--surface);
  border-radius: 12px;
  padding: 32px;
  min-width: 300px;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  animation: slideUp 0.2s ease-out;
}
@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.confirm-body { 
  font-size: 16px; 
  line-height: 1.8; 
  margin-bottom: 24px; 
  color: var(--ink);
  word-break: break-word;
}
.confirm-foot { 
  display: flex; 
  gap: 12px; 
  justify-content: center;
}
.confirm-foot .btn { 
  flex: 0 0 auto;
  min-width: 80px;
  max-width: 80px;
}


/* ---- NE account ---- */
.ne-account { display: flex; flex-direction: column; gap: 8px; }
.ne-form { display: flex; flex-direction: column; gap: 6px; }
.field-input {
  width: 100%; box-sizing: border-box;
  border: 1px solid var(--line); border-radius: var(--radius);
  padding: 7px 9px; font: 13px var(--mono); background: var(--surface); color: var(--ink);
}
.ne-user { display: flex; align-items: center; gap: 10px; }
.ne-avatar { width: 36px; height: 36px; border-radius: 50%; object-fit: cover; flex: 0 0 auto; }
.ne-user-meta { flex: 1; min-width: 0; }
.ne-name { font-weight: 600; font-size: 14px; }
`, "",{"version":3,"sources":["webpack://./src/taskpane/taskpane.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,8EAA8E;EAC9E,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,2EAA2E;EAC3E,uGAAuG;AACzG;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;6EAC6E;AAC7E,WAAW,wBAAwB,EAAE;;AAErC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,OAAO,aAAa,EAAE,sBAAsB,EAAE,aAAa,EAAE,gBAAgB,EAAE;;AAE/E,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;EAC1B,oCAAoC;EACpC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA,SAAS,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvD;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,uEAAuE;AACzE;AACA,cAAc,gBAAgB,EAAE,qBAAqB,EAAE,eAAe,EAAE;AACxE;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB,aAAa,EAAE,QAAQ,EAAE;AAC3C;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW,EAAE,YAAY;EACzB,4BAA4B;EAC5B,eAAe;AACjB;AACA,kBAAkB,qBAAqB,EAAE,iBAAiB,EAAE;;AAE5D,gDAAgD;AAChD;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,4CAA4C;AAC9C;AACA,0BAA0B,2BAA2B,EAAE;AACvD,gBAAgB,0BAA0B,EAAE,OAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAErH;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,EAAE,YAAY,EAAE,UAAU;EAC1C,wBAAwB,EAAE,wBAAwB,EAAE,eAAe;EACnE,0BAA0B,EAAE,0BAA0B;AACxD;AACA,kBAAkB,8BAA8B,EAAE;;AAElD,4BAA4B;AAC5B,SAAS,sBAAsB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEnF;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,cAAc,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,SAAS,EAAE,8BAA8B,EAAE;AACvG,uBAAuB,iBAAiB,EAAE,YAAY,EAAE;;AAExD,YAAY,aAAa,EAAE,qCAAqC,EAAE,QAAQ,EAAE;AAC5E,gBAAgB,qCAAqC,EAAE;;AAEvD;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,0DAA0D;AAC5D;AACA,aAAa,2BAA2B,EAAE,8BAA8B,EAAE;AAC1E,cAAc,4BAA4B,EAAE;AAC5C,gBAAgB,YAAY,EAAE,mBAAmB,EAAE;;AAEnD,eAAe,yBAAyB,EAAE,WAAW,EAAE,2BAA2B,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACnH,qBAAqB,+BAA+B,EAAE,iCAAiC,EAAE;AACzF,aAAa,qBAAqB,EAAE;AACpC,UAAU,gBAAgB,EAAE,iBAAiB,EAAE;;AAE/C;EACE,WAAW;EACX,6BAA6B;EAC7B,4BAA4B;EAC5B,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA,WAAW,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACjE,iBAAiB,gCAAgC,EAAE,mBAAmB,EAAE;;AAExE,OAAO,oBAAoB,EAAE,6BAA6B,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAC5G;EACE,YAAY,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE,mBAAmB;AACpH;AACA,mCAAmC,yBAAyB,EAAE,WAAW,EAAE;AAC3E,uBAAuB,kCAAkC,EAAE;;AAE3D,OAAO,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACrD,WAAW,OAAO,EAAE;AACpB,SAAS,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC1D,YAAY,eAAe,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;;AAE7E,qBAAqB;AACrB,eAAe,sBAAsB,EAAE,gBAAgB,EAAE;AACzD;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,kBAAkB;AACnF;AACA,kBAAkB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC/E,YAAY,qBAAqB,EAAE;AACnC,qBAAqB,YAAY,EAAE;AACnC,qBAAqB,oBAAoB,EAAE,2BAA2B,EAAE;AACxE;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;AACA,wBAAwB,oBAAoB,EAAE,mBAAmB,EAAE;AACnE,eAAe,0BAA0B,EAAE,mBAAmB,EAAE;AAChE,iBAAiB,oBAAoB,EAAE,gBAAgB,EAAE;;AAEzD,0EAA0E;AAC1E,WAAW,mBAAmB,EAAE;AAChC,0BAA0B,aAAa,EAAE;AACzC,yBAAyB,gBAAgB,EAAE;AAC3C;;;cAGc,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACtE,cAAc,eAAe,EAAE;AAC/B,cAAc,eAAe,EAAE;AAC/B,2BAA2B,eAAe,EAAE,mBAAmB,EAAE;AACjE,aAAa,aAAa,EAAE;AAC5B;cACc,aAAa,EAAE,kBAAkB,EAAE;AACjD,cAAc,aAAa,EAAE;AAC7B,qCAAqC,aAAa,EAAE;AACpD,aAAa,oBAAoB,EAAE,0BAA0B,EAAE;AAC/D;EACE,wBAAwB,EAAE,iBAAiB;EAC3C,qBAAqB,EAAE,gBAAgB,EAAE,kBAAkB;AAC7D;AACA;EACE,0BAA0B,EAAE,cAAc;EAC1C,4BAA4B,EAAE,kBAAkB,EAAE,cAAc,EAAE,cAAc;AAClF;AACA,oBAAoB,gBAAgB,EAAE,cAAc,EAAE,UAAU,EAAE,iBAAiB,EAAE;AACrF;EACE,cAAc,EAAE,iBAAiB,EAAE,mBAAmB;EACtD,yCAAyC;AAC3C;AACA,cAAc,YAAY,EAAE,iCAAiC,EAAE,cAAc,EAAE;AAC/E;EACE,yBAAyB,EAAE,WAAW,EAAE,cAAc,EAAE,iBAAiB;AAC3E;AACA;EACE,6BAA6B,EAAE,gBAAgB,EAAE,gBAAgB;AACnE;AACA,cAAc,qBAAqB,EAAE,gBAAgB,EAAE;AACvD,kBAAkB,gBAAgB,EAAE;;AAEpC,gDAAgD;AAChD,SAAS,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AACnD;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,4EAA4E;AAC9E;AACA,cAAc,2BAA2B,EAAE,oBAAoB,EAAE,8BAA8B,EAAE;AACjG,6BAA6B,yBAAyB,EAAE,WAAW,EAAE,2BAA2B,EAAE;AAClG,mCAAmC,+BAA+B,EAAE;AACpE,iBAAiB,aAAa,EAAE,mBAAmB,EAAE;AACrD,WAAW,eAAe,EAAE;AAC5B,uBAAuB,cAAc,EAAE;;AAEvC,oDAAoD;AACpD;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B,cAAc,YAAY,EAAE,iCAAiC,EAAE,iBAAiB,EAAE;;AAElF,8BAA8B;AAC9B,QAAQ,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAClE,gBAAgB,eAAe,EAAE;AACjC;EACE,cAAc;EACd,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,aAAa,8BAA8B,EAAE,yBAAyB,EAAE;AACxE,mBAAmB,oBAAoB,EAAE;AACzC,kBAAkB,0BAA0B,EAAE,6BAA6B,EAAE;AAC7E,aAAa,eAAe,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;;AAExE,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA,oCAAoC,gBAAgB,EAAE,iBAAiB,EAAE;AACzE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;AACA,yBAAyB,UAAU,EAAE,oBAAoB,EAAE;;AAE3D,mEAAmE;AACnE;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW;EACvB,oBAAoB;EACpB,QAAQ;EACR,UAAU;EACV,8BAA8B;AAChC;AACA;6BAC6B,UAAU,EAAE;AACzC;EACE,WAAW,EAAE,YAAY;EACzB,UAAU;EACV,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe,EAAE,cAAc;EAC/B,eAAe;EACf,4EAA4E;AAC9E;AACA,sBAAsB,oBAAoB,EAAE,2BAA2B,EAAE,qBAAqB,EAAE;AAChG,gCAAgC,oBAAoB,EAAE,2BAA2B,EAAE;AACnF,sBAAsB,oBAAoB,EAAE,2BAA2B,EAAE;;AAEzE,eAAe,0BAA0B,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnG,qBAAqB,oBAAoB,EAAE;AAC3C,oBAAoB,kBAAkB,EAAE;;AAExC,6BAA6B;AAC7B;EACE,eAAe,EAAE,QAAQ;EACzB,kCAAkC;EAClC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,WAAW;EACX,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa,EAAE,sBAAsB;EACrC,0CAA0C;EAC1C,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,OAAO,sCAAsC,EAAE,UAAU,EAAE;EAC3D,OAAO,oCAAoC,MAAM,UAAU,EAAE;AAC/D;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;AACA,eAAe,gBAAgB,EAAE,eAAe,EAAE,qBAAqB,EAAE;AACzE;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,aAAa,EAAE,sBAAsB,EAAE,SAAS;AAClD;AACA;EACE,aAAa,EAAE,QAAQ;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,cAAc;AAChB;AACA,mBAAmB,OAAO,EAAE;AAC5B,sEAAsE;AACtE,eAAe,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE;AACnF,eAAe,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AACzD,oBAAoB,OAAO,EAAE;AAC7B,SAAS,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAChG,8BAA8B,iBAAiB,EAAE;AACjD,gBAAgB,gBAAgB,EAAE;AAClC,QAAQ,eAAe,EAAE,mBAAmB,EAAE,aAAa,EAAE,gBAAgB,EAAE;AAC/E,aAAa,wBAAwB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACpG,2EAA2E;AAC3E,wBAAwB,cAAc,EAAE,eAAe,EAAE;;AAEzD;EACE,OAAO,gBAAgB,EAAE;AAC3B;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B,aAAa,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AACvD;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,6BAA6B,EAAE,0BAA0B,EAAE,iBAAiB;EAC5E,oBAAoB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe;AAC3E;AACA,eAAe,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC9E,+BAA+B,2BAA2B,EAAE,yCAAyC,EAAE;;AAEvG,uCAAuC;AACvC,cAAc,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE;AAClF;EACE,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE,eAAe;EAC3D,oBAAoB,EAAE,eAAe,EAAE,0BAA0B,EAAE,0BAA0B;AAC/F;AACA;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC/C,iBAAiB,EAAE,cAAc;EACjC,6BAA6B,EAAE,4BAA4B;EAC3D,gBAAgB,EAAE,0BAA0B;AAC9C;AACA,cAAc,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE;AAC9F,oBAAoB,WAAW,EAAE;;AAEjC,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,uCAAuC;EACvC,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,gBAAgB,EAAE,oCAAoC;AACxD;AACA,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtE,gBAAgB,cAAc,EAAE;AAChC;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe;EACpD,kCAAkC;AACpC;AACA,sBAAsB,8BAA8B,EAAE;AACtD,sBAAsB,OAAO,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AACrI,2BAA2B,OAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpG;EACE,UAAU,EAAE,0BAA0B,EAAE,qBAAqB;EAC7D,mBAAmB,EAAE,qBAAqB;EAC1C,gBAAgB,EAAE,kBAAkB;AACtC;AACA,qBAAqB,0BAA0B,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AACzF;EACE,gBAAgB,EAAE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE,eAAe;EACrF,gBAAgB,EAAE,kBAAkB,EAAE,cAAc;EACpD,UAAU;EACV,8BAA8B;AAChC;AACA;iCACiC,UAAU,EAAE;AAC7C,yBAAyB,oBAAoB,EAAE,qBAAqB,EAAE;AACtE,iBAAiB,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE;;;AAG1F;;gFAEgF;AAChF,eAAe,mBAAmB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,cAAc,EAAE;;AAErG;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,wEAAwE;AACxE;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA,iBAAiB,eAAe,EAAE,cAAc,EAAE;AAClD,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACvE,eAAe,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAEtE,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;AACA,uBAAuB,YAAY,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE7F,4BAA4B;AAC5B,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,WAAW,EAAE;AAClF,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClE;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,iBAAiB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC3D;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE,oBAAoB,cAAc,EAAE;AACpC,yBAAyB,oBAAoB,EAAE;AAC/C,8BAA8B,sBAAsB,EAAE;;AAEtD,sDAAsD;AACtD;EACE,cAAc;EACd,iCAAiC;EACjC,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA,gCAAgC,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,OAAO,EAAE;AACnF,0BAA0B,cAAc,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;;AAEpF,oBAAoB;AACpB;EACE,cAAc;EACd,iCAAiC;EACjC,0BAA0B;EAC1B,qBAAqB;AACvB;AACA,yBAAyB,eAAe,EAAE,gBAAgB,EAAE;AAC5D;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA,4BAA4B,cAAc,EAAE,YAAY,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC9F;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;AACA,kBAAkB,mBAAmB,EAAE,qBAAqB,EAAE;;AAE9D,4BAA4B;AAC5B;EACE,eAAe,EAAE,QAAQ;EACzB,8BAA8B;EAC9B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,gCAAgC;AAClC;AACA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;;AAGA,yBAAyB;AACzB,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/D,WAAW,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC5D;EACE,WAAW,EAAE,sBAAsB;EACnC,6BAA6B,EAAE,4BAA4B;EAC3D,gBAAgB,EAAE,sBAAsB,EAAE,0BAA0B,EAAE,iBAAiB;AACzF;AACA,WAAW,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC1D,aAAa,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC/F,gBAAgB,OAAO,EAAE,YAAY,EAAE;AACvC,WAAW,gBAAgB,EAAE,eAAe,EAAE","sourcesContent":[":root {\n  --bg: #f3f5f4;\n  --surface: #ffffff;\n  --ink: #18211e;\n  --muted: #5e6b66;\n  --line: #dde3e0;\n  --accent: #0f6e5a;\n  --accent-press: #0b5546;\n  --accent-weak: #e6f1ee;\n  --danger: #b23b2e;\n  --warn: #8a5a12;\n  /* themeable accents for the dark context strip, brand mark, and code blocks */\n  --strip-bg: #11201c;\n  --strip-fg: #cfe6df;\n  --strip-eyebrow: #6fae9d;\n  --strip-link: #8fd0bf;\n  --strip-link-hover: #ffffff;\n  --code-bg: #0f1c19;\n  --radius: 6px;\n  --mono: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n  --sans: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Microsoft YaHei\", Roboto, system-ui, sans-serif;\n}\n\n* { box-sizing: border-box; }\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  background: var(--bg);\n  color: var(--ink);\n  font-family: var(--sans);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* The HTML `hidden` attribute must win over any element's display rule\n   (e.g. .drawer { display:flex }), otherwise toggling hidden does nothing. */\n[hidden] { display: none !important; }\n\n.boot {\n  padding: 40px 20px;\n  color: var(--muted);\n  font: 13px/1.5 var(--mono);\n  text-align: center;\n}\n\n#app { display: flex; flex-direction: column; height: 100vh; overflow: hidden; }\n\n/* ---- top bar ---- */\n.topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 12px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--line);\n  position: sticky;\n  top: 0;\n  z-index: 5;\n}\n.brand { display: flex; align-items: center; gap: 7px; }\n.brand-mark {\n  width: 12px; height: 12px; border-radius: 3px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-press));\n}\n.brand-name { font-weight: 650; letter-spacing: 0.2px; font-size: 13px; }\n.badge {\n  font: 10px/1 var(--mono);\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--accent);\n  background: var(--accent-weak);\n  padding: 3px 5px;\n  border-radius: 4px;\n}\n\n.topbar-actions { display: flex; gap: 2px; }\n.icon-btn {\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--muted);\n  font-size: 14px;\n  width: 26px; height: 26px;\n  border-radius: var(--radius);\n  cursor: pointer;\n}\n.icon-btn:hover { background: var(--bg); color: var(--ink); }\n\n/* ---- context strip (signature element) ---- */\n.context-strip {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  padding: 9px 16px;\n  background: var(--strip-bg);\n  color: var(--strip-fg);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.25);\n}\n.context-strip .eyebrow { color: var(--strip-eyebrow); }\n.context-text { font: 12px/1.4 var(--mono); flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n.eyebrow {\n  font: 10px/1 var(--mono);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--muted);\n}\n\n.link-btn {\n  background: none; border: none; padding: 0;\n  color: var(--strip-link); font: 11px/1 var(--mono); cursor: pointer;\n  text-decoration: underline; text-underline-offset: 2px;\n}\n.link-btn:hover { color: var(--strip-link-hover); }\n\n/* ---- panel / cards ---- */\n.panel { padding: 16px 16px 8px; display: flex; flex-direction: column; gap: 14px; }\n\n.card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n}\n.card-title { display: flex; align-items: center; gap: 8px; margin: 0; justify-content: space-between; }\n.card-title .eyebrow { color: var(--ink); opacity: 0.7; }\n\n.btn-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }\n.btn-grid.two { grid-template-columns: repeat(2, 1fr); }\n\n.btn {\n  appearance: none;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--ink);\n  border-radius: var(--radius);\n  padding: 6px 10px;\n  font-size: 12.5px;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease;\n}\n.btn:hover { border-color: var(--accent); background: var(--accent-weak); }\n.btn:active { transform: translateY(0.5px); }\n.btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.btn-primary { background: var(--accent); color: #fff; border-color: var(--accent); width: 100%; font-weight: 600; }\n.btn-primary:hover { background: var(--accent-press); border-color: var(--accent-press); }\n.btn-ghost { background: var(--bg); }\n.btn-sm { padding: 4px 7px; font-size: 11.5px; }\n\ntextarea, input[type=\"text\"], input[type=\"password\"], select {\n  width: 100%;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 9px 10px;\n  font: 13px var(--sans);\n  background: var(--surface);\n  color: var(--ink);\n}\ntextarea { resize: vertical; min-height: 72px; line-height: 1.5; }\n:focus-visible { outline: 2px solid var(--accent); outline-offset: 1px; }\n\n.seg { display: inline-flex; border: 1px solid var(--line); border-radius: var(--radius); overflow: hidden; }\n.seg button {\n  border: none; background: var(--surface); padding: 6px 11px; font-size: 12px; cursor: pointer; color: var(--muted);\n}\n.seg button[aria-pressed=\"true\"] { background: var(--accent); color: #fff; }\n.seg button + button { border-left: 1px solid var(--line); }\n\n.row { display: flex; gap: 8px; align-items: center; }\n.row > * { flex: 1; }\n.stack { display: flex; flex-direction: column; gap: 8px; }\n.label-sm { font-size: 12px; color: var(--muted); margin: 0; display: block; }\n\n/* ---- output ---- */\n.output-wrap { padding: 8px 16px 18px; margin-top: auto; }\n.output-head {\n  display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 8px;\n}\n.output-actions { display: flex; gap: 6px; flex-wrap: wrap; margin-left: auto; }\n.copy-btn { background: var(--bg); }\n.copy-btn:disabled { opacity: 0.5; }\n.copy-btn.is-error { color: var(--danger); border-color: var(--danger); }\n.output {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 12px 14px;\n  min-height: 90px;\n  max-height: 44vh;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 13.5px;\n  line-height: 1.62;\n}\n.output:empty::before { content: \"结果会显示在这里。\"; color: var(--muted); }\n.output .log { font: 12px/1.6 var(--mono); color: var(--muted); }\n.output .log b { color: var(--accent); font-weight: 600; }\n\n/* rendered markdown (shared by the single result view and chat bubbles) */\n.md-body { white-space: normal; }\n.md-body > :first-child { margin-top: 0; }\n.md-body > :last-child { margin-bottom: 0; }\n.md-body h3,\n.md-body h4,\n.md-body h5,\n.md-body h6 { margin: 10px 0 4px; line-height: 1.3; font-weight: 650; }\n.md-body h3 { font-size: 14px; }\n.md-body h4 { font-size: 13px; }\n.md-body h5, .md-body h6 { font-size: 12px; color: var(--muted); }\n.md-body p { margin: 6px 0; }\n.md-body ul,\n.md-body ol { margin: 8px 0; padding-left: 20px; }\n.md-body li { margin: 3px 0; }\n.md-body li > ul, .md-body li > ol { margin: 3px 0; }\n.md-body a { color: var(--accent); text-underline-offset: 2px; }\n.md-body code {\n  font-family: var(--mono); font-size: 12.5px;\n  background: var(--bg); padding: 1px 5px; border-radius: 4px;\n}\n.md-body pre {\n  background: var(--code-bg); color: #d7e9e3;\n  border-radius: var(--radius); padding: 10px 12px; margin: 10px 0; overflow: auto;\n}\n.md-body pre code { background: none; color: inherit; padding: 0; font-size: 12.5px; }\n.md-body blockquote {\n  margin: 10px 0; padding: 4px 12px; color: var(--muted);\n  border-left: 3px solid var(--accent-weak);\n}\n.md-body hr { border: none; border-top: 1px solid var(--line); margin: 14px 0; }\n.md-body table {\n  border-collapse: collapse; width: 100%; margin: 10px 0; font-size: 12.5px;\n}\n.md-body th, .md-body td {\n  border: 1px solid var(--line); padding: 6px 8px; text-align: left;\n}\n.md-body th { background: var(--bg); font-weight: 600; }\n.md-body strong { font-weight: 650; }\n\n/* ---- chips (recommended quick-actions) ---- */\n.chips { display: flex; flex-wrap: wrap; gap: 6px; }\n.chip {\n  appearance: none;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--ink);\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 11.5px;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n.chip:hover { border-color: var(--accent); color: var(--accent); background: var(--accent-weak); }\n.chip[aria-pressed=\"true\"] { background: var(--accent); color: #fff; border-color: var(--accent); }\n.chip[aria-pressed=\"true\"]:hover { background: var(--accent-press); }\n.chip:disabled { opacity: 0.45; cursor: not-allowed; }\n.net-row { margin-top: 2px; }\n.net-row .net-toggle { flex: 0 0 auto; }\n\n/* agent tool trace shown above an assistant reply */\n.trace {\n  font: 11px/1.5 var(--mono);\n  color: var(--muted);\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 6px;\n  padding: 4px 7px;\n  margin-bottom: 6px;\n}\n\n/* footer model line */\n.model-footer {\n  padding: 4px 12px 5px;\n  font: 10.5px/1.4 var(--mono);\n  color: var(--muted);\n  border-top: 1px solid var(--line);\n}\n\n/* settings drawer separator */\n.drawer-sep { border: none; border-top: 1px solid var(--line); margin: 8px 0 2px; }\n\n/* ---- chat transcript ---- */\n.turn { border-radius: 8px; padding: 7px 9px; position: relative; }\n.turn + .turn { margin-top: 6px; }\n.turn .role {\n  display: block;\n  font: 10px/1 var(--mono);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--muted);\n  margin-bottom: 3px;\n}\n.turn.user { background: var(--accent-weak); border: 1px solid #d3e6e0; }\n.turn.user .role { color: var(--accent); }\n.turn.assistant { background: var(--surface); border: 1px solid var(--line); }\n.turn-body { font-size: 13px; line-height: 1.55; white-space: pre-wrap; }\n\n/* User messages: collapse long content (e.g. when Office data is attached). */\n.turn.user .turn-body {\n  max-height: 10em;\n  overflow: hidden;\n}\n.turn.user .turn-body.is-expanded { max-height: none; overflow: visible; }\n.turn-expand-btn {\n  display: block;\n  width: 100%;\n  border: none;\n  background: none;\n  color: var(--muted);\n  font-size: 11px;\n  cursor: pointer;\n  padding: 2px 0;\n  text-align: center;\n  opacity: 0.6;\n  transition: opacity 0.12s;\n}\n.turn-expand-btn:hover { opacity: 1; color: var(--accent); }\n\n/* Per-message action toolbar (copy + delete), revealed on hover. */\n.turn-actions {\n  position: absolute;\n  right: 4px; bottom: 4px;\n  display: inline-flex;\n  gap: 3px;\n  opacity: 0;\n  transition: opacity 0.12s ease;\n}\n.turn:hover .turn-actions,\n.turn-actions:focus-within { opacity: 1; }\n.turn-act-btn {\n  width: 20px; height: 20px;\n  padding: 0;\n  display: inline-flex; align-items: center; justify-content: center;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 4px;\n  color: var(--muted);\n  font-size: 11px; line-height: 1;\n  cursor: pointer;\n  transition: color 0.12s ease, border-color 0.12s ease, background 0.12s ease;\n}\n.turn-act-btn:hover { color: var(--accent); border-color: var(--accent); background: var(--bg); }\n.turn-act-btn.is-danger:hover { color: var(--danger); border-color: var(--danger); }\n.turn-act-btn.is-ok { color: var(--accent); border-color: var(--accent); }\n\n.status-line { font: 11px/1.4 var(--mono); color: var(--muted); margin: 4px 0 0; min-height: 14px; }\n.status-line.error { color: var(--danger); }\n.status-line.warn { color: var(--warn); }\n\n/* ---- settings modal ---- */\n.modal-overlay {\n  position: fixed; inset: 0;\n  background: rgba(10, 20, 17, 0.45);\n  display: flex; align-items: center; justify-content: center;\n  z-index: 50;\n  padding: 16px;\n  backdrop-filter: blur(2px);\n}\n.modal-card {\n  background: var(--surface);\n  width: 100%;\n  max-width: 480px;\n  max-height: 90vh;\n  border-radius: 12px;\n  display: flex; flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  animation: modalPop 0.18s ease-out;\n}\n@keyframes modalPop {\n  from { transform: translateY(8px) scale(0.98); opacity: 0; }\n  to   { transform: translateY(0)    scale(1);     opacity: 1; }\n}\n.modal-head {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--line);\n  flex: 0 0 auto;\n}\n.modal-title { font-weight: 650; font-size: 14px; letter-spacing: 0.2px; }\n.modal-body {\n  padding: 14px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  display: flex; flex-direction: column; gap: 11px;\n}\n.modal-foot {\n  display: flex; gap: 8px;\n  padding: 10px 14px;\n  border-top: 1px solid var(--line);\n  background: var(--surface);\n  flex: 0 0 auto;\n}\n.modal-foot .btn { flex: 1; }\n/* Keep legacy .drawer-* class names usable for any leftover markup. */\n.drawer-head { display: flex; align-items: center; justify-content: space-between; }\n.drawer-foot { display: flex; gap: 8px; margin-top: 4px; }\n.drawer-foot .btn { flex: 1; }\n.field { display: flex; flex-direction: column; gap: 6px; font-size: 12px; color: var(--muted); }\n.field input, .field select { color: var(--ink); }\n.field > span { font-weight: 500; }\n.hint { font-size: 11px; color: var(--muted); margin: 2px 0; line-height: 1.5; }\n.hint code { font-family: var(--mono); background: var(--bg); padding: 1px 4px; border-radius: 3px; }\n/* In-body small buttons (测试 / 导入 / 导出): keep them tight, not full-width. */\n.modal-body .row .btn { flex: 0 0 auto; min-width: 72px; }\n\n@media (prefers-reduced-motion: reduce) {\n  .btn { transition: none; }\n}\n\n/* ---- themes ---- */\n:root[data-theme=\"blue\"] {\n  --accent: #2563eb;\n  --accent-press: #1d4ed8;\n  --accent-weak: #e7effd;\n  --strip-bg: #0c1a2e;\n  --strip-fg: #d2e2f6;\n  --strip-eyebrow: #6f9fd6;\n  --strip-link: #9cc0ee;\n  --code-bg: #0c1726;\n}\n:root[data-theme=\"anthropic\"] {\n  --bg: #f4f1ea;\n  --surface: #fffdf8;\n  --line: #e6ded0;\n  --accent: #c8633b;\n  --accent-press: #aa4f2c;\n  --accent-weak: #f6e9e0;\n  --strip-bg: #2a2018;\n  --strip-fg: #ecdcc9;\n  --strip-eyebrow: #c79b78;\n  --strip-link: #e3b791;\n  --strip-link-hover: #fff5ea;\n  --code-bg: #241c14;\n}\n:root[data-theme=\"govred\"] {\n  --accent: #c8102e;\n  --accent-press: #9e0c24;\n  --accent-weak: #fbe6ea;\n  --strip-bg: #2a1012;\n  --strip-fg: #f3d6d9;\n  --strip-eyebrow: #cf8f95;\n  --strip-link: #ec9aa1;\n  --code-bg: #260e10;\n}\n\n/* theme switcher swatches */\n.theme-row { display: flex; flex-wrap: wrap; gap: 8px; }\n.swatch {\n  display: inline-flex; align-items: center; gap: 6px;\n  border: 1px solid var(--line); background: var(--surface); color: var(--ink);\n  border-radius: 999px; padding: 5px 11px; font-size: 12px; cursor: pointer;\n}\n.swatch .dot { width: 12px; height: 12px; border-radius: 50%; flex: 0 0 auto; }\n.swatch[aria-pressed=\"true\"] { border-color: var(--accent); box-shadow: inset 0 0 0 1px var(--accent); }\n\n/* ---- Excel multi-sheet picker ---- */\n.sheet-head { display: flex; align-items: center; justify-content: space-between; }\n.link-btn-2 {\n  background: none; border: none; padding: 0; cursor: pointer;\n  color: var(--accent); font-size: 12px; text-decoration: underline; text-underline-offset: 2px;\n}\n.sheet-list {\n  display: flex; flex-direction: column; gap: 2px;\n  max-height: 132px; overflow: auto;\n  border: 1px solid var(--line); border-radius: var(--radius);\n  padding: 6px 8px; background: var(--surface);\n}\n.sheet-item { display: flex; align-items: center; gap: 8px; font-size: 13px; cursor: pointer; }\n.sheet-item input { width: auto; }\n\n/* ---- history dropdown ---- */\n.history-dropdown {\n  position: absolute;\n  top: 44px;\n  right: 4px;\n  width: 260px;\n  max-height: 50vh;\n  overflow-y: auto;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  box-shadow: 0 4px 16px rgba(0,0,0,0.12);\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n}\n.history-head {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 6px 8px; border-bottom: 1px solid var(--line);\n}\n.history-head-actions { display: flex; align-items: center; gap: 4px; }\n.history-list { padding: 4px 0; }\n.history-item {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 6px 8px; font-size: 12.5px; cursor: pointer;\n  border-bottom: 1px solid var(--bg);\n}\n.history-item:hover { background: var(--accent-weak); }\n.history-item-title { flex: 1; display: flex; align-items: center; gap: 6px; overflow: hidden; margin-right: 6px; color: var(--ink); }\n.history-item-title-text { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.history-host-badge {\n  flex: none; font: 10px/1.5 var(--mono); letter-spacing: 0.4px;\n  color: var(--muted); background: var(--bg);\n  padding: 1px 5px; border-radius: 4px;\n}\n.history-item-date { font: 11px/1.4 var(--mono); color: var(--muted); margin-right: 6px; }\n.history-del-btn {\n  background: none; border: none; color: var(--muted); font-size: 14px; cursor: pointer;\n  padding: 2px 4px; border-radius: 4px; line-height: 1;\n  opacity: 0;\n  transition: opacity 0.12s ease;\n}\n.history-item:hover .history-del-btn,\n.history-del-btn:focus-visible { opacity: 1; }\n.history-del-btn:hover { color: var(--danger); background: var(--bg); }\n.history-empty { text-align: center; padding: 16px; color: var(--muted); font-size: 12px; }\n\n\n/* ===========================================================================\n   Chatbot layout (transcript + bottom composer)\n   =========================================================================== */\n.extra-panel { padding: 8px 12px 0; display: flex; flex-direction: column; gap: 8px; flex: 0 0 auto; }\n\n.transcript {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 10px 12px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* welcome / empty state — horizontally & vertically centered via flex */\n.welcome {\n  margin: auto;\n  padding: 16px 12px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n  text-align: center;\n  color: var(--muted);\n  max-width: 360px;\n}\n.welcome-greet {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n}\n.welcome-emoji { font-size: 28px; line-height: 1; }\n.welcome-title { font-size: 15px; font-weight: 650; color: var(--ink); }\n.welcome-sub { font-size: 11.5px; line-height: 1.5; max-width: 300px; }\n\n/* host capability bullets */\n.welcome-caps {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n  text-align: left;\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 8px 10px;\n  width: 100%;\n}\n.welcome-cap {\n  font-size: 11.5px;\n  color: var(--muted);\n  display: flex;\n  gap: 5px;\n  align-items: flex-start;\n}\n.welcome-cap::before { content: \"✓\"; color: var(--accent); font-weight: 700; flex: 0 0 auto; }\n\n/* example question groups */\n.welcome-examples { display: flex; flex-direction: column; gap: 8px; width: 100%; }\n.welcome-group { display: flex; flex-direction: column; gap: 4px; }\n.welcome-group-label {\n  font: 10px/1 var(--mono);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--muted);\n  text-align: left;\n}\n.welcome-chips { display: flex; flex-wrap: wrap; gap: 5px; }\n.welcome-chip {\n  max-width: 100%;\n  text-align: left;\n  white-space: normal;\n  line-height: 1.4;\n  padding: 6px 9px;\n  font-size: 11.5px;\n}\n\n/* chat bubbles (overrides the older .turn block for the new flow) */\n.transcript .turn { max-width: 92%; }\n.transcript .turn.user { align-self: flex-end; }\n.transcript .turn.assistant { align-self: flex-start; }\n\n/* last-result actions bar (sits above the composer) */\n.last-actions {\n  flex: 0 0 auto;\n  border-top: 1px solid var(--line);\n  background: var(--surface);\n  padding: 6px 10px;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.last-actions .output-actions { display: flex; gap: 6px; flex-wrap: wrap; flex: 1; }\n.last-actions .copy-btn { flex: 0 0 auto; margin-left: auto; background: var(--bg); }\n\n/* bottom composer */\n.composer {\n  flex: 0 0 auto;\n  border-top: 1px solid var(--line);\n  background: var(--surface);\n  padding: 6px 10px 8px;\n}\n.composer .status-line { margin: 0 0 4px; min-height: 12px; }\n.composer textarea {\n  width: 100%;\n  min-height: 44px;\n  max-height: 140px;\n  resize: none;\n  line-height: 1.5;\n  box-sizing: border-box;\n  font-size: 13px;\n  padding: 7px 9px;\n}\n.composer-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 6px;\n}\n.composer-bar .net-toggle { flex: 0 0 auto; height: 30px; line-height: 18px; font-size: 12px; }\n.btn-send {\n  flex: 0 0 auto;\n  min-width: 60px;\n  width: auto;\n  height: 30px;\n  font-weight: 600;\n  padding-top: 0;\n  padding-bottom: 0;\n  font-size: 12.5px;\n}\n.btn-stop {\n  background: var(--danger);\n  color: #fff;\n  border-color: var(--danger);\n}\n.btn-stop:hover { background: #8e2f24; border-color: #8e2f24; }\n\n/* ---- confirm modal ---- */\n.confirm-overlay {\n  position: fixed; inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex; align-items: center; justify-content: center;\n  z-index: 100;\n  backdrop-filter: blur(2px);\n}\n.confirm-card {\n  background: var(--surface);\n  border-radius: 12px;\n  padding: 32px;\n  min-width: 300px;\n  max-width: 420px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.3);\n  animation: slideUp 0.2s ease-out;\n}\n@keyframes slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n.confirm-body { \n  font-size: 16px; \n  line-height: 1.8; \n  margin-bottom: 24px; \n  color: var(--ink);\n  word-break: break-word;\n}\n.confirm-foot { \n  display: flex; \n  gap: 12px; \n  justify-content: center;\n}\n.confirm-foot .btn { \n  flex: 0 0 auto;\n  min-width: 80px;\n  max-width: 80px;\n}\n\n\n/* ---- NE account ---- */\n.ne-account { display: flex; flex-direction: column; gap: 8px; }\n.ne-form { display: flex; flex-direction: column; gap: 6px; }\n.field-input {\n  width: 100%; box-sizing: border-box;\n  border: 1px solid var(--line); border-radius: var(--radius);\n  padding: 7px 9px; font: 13px var(--mono); background: var(--surface); color: var(--ink);\n}\n.ne-user { display: flex; align-items: center; gap: 10px; }\n.ne-avatar { width: 36px; height: 36px; border-radius: 50%; object-fit: cover; flex: 0 0 auto; }\n.ne-user-meta { flex: 1; min-width: 0; }\n.ne-name { font-weight: 600; font-size: 14px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
